
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
import { ValidationProvider } from 'vee-validate';

import { sharedState } from '../../framework/state';
import { getDatabaseOptions, OptionValue } from '../../framework/service/options';
import { getFieldNameFromVModelProperty } from '../../framework/util/component_util';
import { InvoiceRowType } from '../../../common/application/model/enums/InvoiceRowType';
import { debounce } from 'lodash';

@Component({
    components: {
        Multiselect,
        ValidationProvider,
    },
})
export default class InvoiceRowTypeSelectField extends Vue {
    @Prop(Boolean) readonly disabled!: string;
    @Prop(Boolean) readonly expanded!: boolean;
    @Prop(String) readonly idField!: string;
    @Prop(Boolean) readonly multiple!: boolean;
    @Prop(String) readonly name!: string;
    @Prop(Boolean) readonly required!: boolean;
    @Prop(Array) readonly value!: string[];

    shared = sharedState;

    local = {
        filteredObjects: [] as OptionValue[],
        selectedResources: [] as OptionValue[],
        allObjects: [] as OptionValue[],
        isLoading: false,
    };

    async mounted() {
        this.local.filteredObjects = (await getDatabaseOptions('InvoiceRowType', this)).filter((option) => {
            if (
                option.id !== undefined &&
                option.id !== InvoiceRowType.SMARTFLEET_INITIAL_FEE &&
                option.id !== InvoiceRowType.SMARTFLEET_MONTHLY_FEE
            ) {
                return option;
            }
        });
        this.local.allObjects = [...this.local.filteredObjects];
        await this.modelValueChange(this.value);
    }

    @Watch('value')
    async modelValueChange(newValue: string[]) {
        this.local.selectedResources = [];

        if (!newValue) {
            return;
        }

        newValue.forEach((resourceId) => {
            const resource = this.local.filteredObjects.find(({ id }) => resourceId === id);

            if (resource) {
                this.local.selectedResources.push(resource);
            }
        });
    }

    dropdownClosed(opened: boolean) {
        if (!opened) {
            let value: string[];

            if (this.multiple) {
                value = this.local.selectedResources.map(({ id }) => id!!);
            } else {
                value = [(this.local.selectedResources as any).id];
            }
            this.$emit('dropdown-closed', value, this.idField);
        }
    }

    clearAll(): void {
        this.local.selectedResources = [];
    }

    selectAll(): void {
        this.local.selectedResources = [...this.local.filteredObjects];
    }

    getFieldName(): string {
        return getFieldNameFromVModelProperty(this);
    }

    deBouncedSearch = debounce((searchString: string) => {
        this.search(searchString);
    }, 350);

    search(searchString: string): void {
        this.local.isLoading = true;
        const filteredObjects = this.local.allObjects.filter((object) =>
            object.label.toLowerCase().startsWith(searchString.toLowerCase()),
        );

        this.local.filteredObjects = [...filteredObjects];
        this.local.isLoading = false;
    }
}
